import { render, staticRenderFns } from "./town.vue?vue&type=template&id=3969d209&"
import script from "./town.vue?vue&type=script&lang=js&"
export * from "./town.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports